<app-navbar />
<div class="">
	<router-outlet />
</div>
@if (appState().loadingOverlay) {
	<activar-loading-overlay />
}
@if (version) {
	<span class="app-version">v{{ version }}</span>
}
